import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Option } from '@fluentui/react-components';
import { SUPPORTED_LANGUAGES } from '../i18n';

const LANGUAGE_LABELS: Record<string, string> = {
  'de': 'Deutsch',
  'en': 'English',
  'es': 'Español',
  'fr': 'Français',
  'it': 'Italiano',
  'zh-CN': '中文 (简体)',
};

interface LanguageSelectorProps {
  className?: string;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className = '' }) => {
  const { i18n, t } = useTranslation('common');

  const handleChange = (_: any, data: any) => {
    const lang = data.optionValue as string;
    console.log('[LanguageSelector] Language change initiated:', {
      newLanguage: lang,
      previousLanguage: i18n.language,
      timestamp: new Date().toISOString(),
    });
    
    localStorage.setItem('requestateam_language', lang);
    console.log('[LanguageSelector] localStorage updated:', {
      key: 'requestateam_language',
      value: localStorage.getItem('requestateam_language'),
    });
    
    i18n.changeLanguage(lang).then(() => {
      console.log('[LanguageSelector] Language change completed:', {
        newLanguage: i18n.language,
      });
    }).catch((err) => {
      console.error('[LanguageSelector] Language change failed:', err);
    });
    
    // Update HTML dir attribute for RTL support (future-proof)
    document.documentElement.dir = ['ar', 'he', 'fa'].includes(lang) ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  };

  return (
    <div className={`language-selector ${className}`}>
      <label htmlFor="language-dropdown">{t('settings.language', 'Language')}</label>
      <Dropdown
        id="language-dropdown"
        value={LANGUAGE_LABELS[i18n.language] || i18n.language}
        onOptionSelect={handleChange}
      >
        {SUPPORTED_LANGUAGES.map(lang => (
          <Option key={lang} value={lang}>{LANGUAGE_LABELS[lang]}</Option>
        ))}
      </Dropdown>
    </div>
  );
};

export default LanguageSelector;
